/**
 * TrulyHungry — Media Modal
 * Extracted from layout/theme.liquid for performance.
 */
      // â”€â”€ Media Modal â”€â”€
      (function () {
        var mediaModal = document.getElementById('media-modal');
        var modalClose = document.getElementById('media-modal-close');
        var modalContent = document.getElementById('modal-content');
        var modalTitle = document.getElementById('modal-title');
        var modalSubtitle = document.getElementById('modal-subtitle');
        var modalATC = document.getElementById('modal-atc');
        var modalBuy = document.getElementById('modal-buy');
        var modalViewProduct = document.getElementById('modal-view-product');
        var modalNoProduct = document.getElementById('modal-no-product');
        var modalBuyArea = document.getElementById('modal-buy-area');
        var modalNoContent = document.getElementById('modal-no-content');
        var modalPriceRow = document.getElementById('modal-price-row');
        var modalPrice = document.getElementById('modal-price');
        var modalCompare = document.getElementById('modal-compare');
        var modalBadge = document.getElementById('modal-badge');
        var modalPaymentContainer = document.getElementById('modal-payment-button-container');

        var _variantId = null;
        var _productUrl = null;
        var _invQty = 999999;
        var _invPolicy = 'continue';
        var _currentParentSection = null;

        // Slider vars
        var allTriggers = [];
        var currentIndex = 0;
        var btnPrev = document.getElementById('global-modal-prev');
        var btnNext = document.getElementById('global-modal-next');

        function updateModalContent(trigger, isInitial) {
          if (!trigger) return;
          
          var type = trigger.getAttribute('data-type') || 'image';
          var src = trigger.getAttribute('data-src') || '';
          
          // Reset placeholders to hidden by default
          if (modalNoContent) modalNoContent.style.display = 'none';
          if (modalNoProduct) modalNoProduct.style.display = 'none';
          
          modalContent.innerHTML = '';
          
          if (!src) {
            if (modalNoContent) modalNoContent.style.display = 'flex';
            modalContent.style.display = 'none';
            if (btnPrev) btnPrev.style.display = 'none';
            if (btnNext) btnNext.style.display = 'none';
          } else {
            if (modalNoContent) modalNoContent.style.display = 'none';
            
            if (allTriggers.length > 1) {
              modalContent.style.display = 'block';
              modalContent.style.overflow = 'hidden';

              var swiperEl = document.createElement('div');
              swiperEl.className = 'swiper';
              swiperEl.style.cssText = 'width:100%;height:100%;';
              var swiperWrapper = document.createElement('div');
              swiperWrapper.className = 'swiper-wrapper';

              allTriggers.forEach(function(trig) {
                var slideType = trig.getAttribute('data-type') || 'image';
                var slideSrc = trig.getAttribute('data-src') || '';
                var slide = document.createElement('div');
                slide.className = 'swiper-slide';
                slide.style.cssText = 'display:flex;align-items:center;justify-content:center;';

                if (slideType === 'video' && slideSrc) {
                  var vid = document.createElement('video');
                  vid.src = slideSrc;
                  vid.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:var(--border-radius);box-shadow:0 20px 60px rgba(0,0,0,0.5);background:#000;display:block;';
                  vid.controls = true; vid.playsInline = true; vid.muted = true; vid.loop = true;
                  slide.appendChild(vid);
                } else if (slideSrc) {
                  var img = document.createElement('img');
                  img.src = slideSrc;
                  img.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:var(--border-radius);box-shadow:0 20px 60px rgba(0,0,0,0.25);display:block;';
                  slide.appendChild(img);
                }
                swiperWrapper.appendChild(slide);
              });

              swiperEl.appendChild(swiperWrapper);
              modalContent.appendChild(swiperEl);

              if (btnPrev) btnPrev.style.display = 'flex';
              if (btnNext) btnNext.style.display = 'flex';

              if (window.globalModalSwiper) { 
                window.globalModalSwiper.destroy(true, true); 
                window.globalModalSwiper = null; 
              }
              
              window.globalModalSwiper = new Swiper(swiperEl, {
                loop: true,
                speed: 400,
                spaceBetween: 16,
                grabCursor: true,
                navigation: { nextEl: btnNext, prevEl: btnPrev },
                on: {
                  realIndexChange: function(swiper) {
                    currentIndex = swiper.realIndex;
                    updateModalContentData(allTriggers[currentIndex]);
                  }
                }
              });
              if (currentIndex > 0) {
                 window.globalModalSwiper.slideToLoop(currentIndex, 0);
              }
            } else {
              modalContent.style.display = 'flex';
              modalContent.style.overflow = '';
              if (type === 'video') {
                var v = document.createElement('video');
                v.src = src; v.controls = true; v.autoplay = true; v.muted = true; v.loop = true; v.playsInline = true;
                v.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:var(--border-radius);box-shadow:var(--theme-shadow);background:#000;display:block;';
                v.className = 'w-full h-full object-cover shadow-2xl bg-black';
                modalContent.appendChild(v);
              } else {
                var img = document.createElement('img');
                img.src = src;
                img.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:var(--border-radius);box-shadow:var(--theme-shadow);background:#000;display:block;';
                img.className = 'w-full h-full object-cover shadow-2xl bg-black';
                modalContent.appendChild(img);
              }
              if (btnPrev) btnPrev.style.display = 'none';
              if (btnNext) btnNext.style.display = 'none';
            }
          }
          
          updateModalContentData(trigger, isInitial);
        }

        function goToSlide(index) {
          if (window.globalModalSwiper) {
            var logicalIndex = (index + allTriggers.length) % allTriggers.length;
            window.globalModalSwiper.slideToLoop(logicalIndex, 400);
          }
        }

        // Separate function to update content data without recreating slider
        function updateModalContentData(trigger, isInitial) {
          if (!trigger) return;
          var title = trigger.getAttribute('data-product-title') || '';
          var desc = trigger.getAttribute('data-product-desc') || '';
          var rawVid = trigger.getAttribute('data-variant-id');
          var purl = trigger.getAttribute('data-product-url');
          
          _variantId = rawVid && rawVid !== '' && rawVid !== '0' ? parseInt(rawVid, 10) : null;
          _productUrl = purl || null;
          _invQty = parseInt(trigger.getAttribute('data-inv-qty') || '999999');
          _invPolicy = trigger.getAttribute('data-inv-policy') || 'continue';
          
          var pprice = trigger.getAttribute('data-product-price') || '';
          var pcompare = trigger.getAttribute('data-product-compare') || '';
          var pdiscount = trigger.getAttribute('data-product-discount') || '';
          
          if (modalPrice) {
            modalPrice.textContent = pprice;
            if (modalPriceRow) {
              var cleanPrice = pprice.replace(/[^0-9]/g, '');
              modalPriceRow.style.display = (pprice && cleanPrice !== '0' && cleanPrice !== '') ? 'flex' : 'none';
            }
          }
          if (modalViewProduct) {
             modalViewProduct.href = purl || '#';
             modalViewProduct.style.display = purl ? '' : 'none';
          }

          if (modalPaymentContainer) {
            // â”€â”€ PAYMENT BUTTON STRATEGY â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            // The PDP page has a properly-initialised Shopify payment form:
            //   #pdp-modal-product-form  /  input#pdp-modal-variant-id
            // Its accelerated buttons (Shop Pay, Apple Pay, Google Pay) are live
            // iframes already bound to that form's variant input.
            //
            // Previous approach (move card hidden form + re-init) failed because:
            //   1. Moving iframe-containing nodes destroys the iframes silently.
            //   2. PaymentButton.init() re-binds ALL forms and picks the PDP form
            //      first, so the WRONG product variant went to checkout.
            //
            // Correct approach:
            //   1. Just update #pdp-modal-variant-id to _variantId (modal product).
            //   2. Move the already-live #pdp-modal-payment-btn-wrap <div> into
            //      our modal container. The iframes stay alive because we are only
            //      moving the wrapper div, not the <form> they were initialised in.
            //   3. On close, move it back and restore the original PDP variant.
            //   4. Always show modal-buy (green button) as a reliable fallback.

            // 1. First, check for a local form in the triggering card (BEST SOURCE)
            var cardPayWrap = trigger.querySelector('.hidden-checkout-form');
            if (!cardPayWrap) {
               var parentCard = trigger.closest('[data-product-id], article, .card-shadow');
               if (parentCard) {
                  cardPayWrap = parentCard.querySelector('.hidden-checkout-form');
               }
            }

            // 2. Fallback to PDP form ONLY if it matches the current variant OR no card form exists
            var pdpPayWrap = document.getElementById('pdp-modal-payment-btn-wrap');
            var pdpVariantInput = document.getElementById('pdp-modal-variant-id');
            
            // If we found a card-specific form, use it
            if (cardPayWrap && _variantId) {
               // Create placeholder to move it back later (unique ID for safety)
               var phId = 'th-card-pay-placeholder-' + Math.random().toString(36).substr(2, 9);
               var ph = document.createElement('span');
               ph.id = phId;
               ph.style.display = 'none';
               cardPayWrap.parentNode.insertBefore(ph, cardPayWrap.nextSibling);

               modalPaymentContainer.innerHTML = '';
               // Temporarily override the hidden styles so it shows up in modal
               cardPayWrap.style.opacity = '1';
               cardPayWrap.style.visibility = 'visible';
               cardPayWrap.style.position = 'relative';
               cardPayWrap.style.zIndex = '100';
               cardPayWrap.style.pointerEvents = 'auto';

               modalPaymentContainer.appendChild(cardPayWrap);
               modalPaymentContainer.style.display = 'block';
               window._currentActiveCardPayWrap = cardPayWrap;
               window._currentActiveCardPlaceholderId = phId;
               
               // Re-init for Shopify buttons
               setTimeout(function() {
                 if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
                   window.Shopify.PaymentButton.init();
                 }
               }, 10);
            } 
            // Only use PDP form if no card form was found and PDP form is available
            else if (pdpPayWrap && _variantId) {
              if (pdpVariantInput) {
                if (!pdpVariantInput.hasAttribute('data-original-value')) {
                  pdpVariantInput.setAttribute('data-original-value', pdpVariantInput.value);
                }
                pdpVariantInput.value = String(_variantId);
              }

              if (!document.getElementById('th-pay-wrap-placeholder')) {
                var ph = document.createElement('span');
                ph.id = 'th-pay-wrap-placeholder';
                ph.style.display = 'none';
                pdpPayWrap.parentNode.insertBefore(ph, pdpPayWrap);
              }

              modalPaymentContainer.innerHTML = '';
              modalPaymentContainer.appendChild(pdpPayWrap);
              modalPaymentContainer.style.display = 'block';
              window._currentActivePayWrap = pdpPayWrap;
            } else {
              modalPaymentContainer.style.display = 'none';
            }

          }
          if (modalCompare) {
            modalCompare.textContent = pcompare;
            modalCompare.style.display = pcompare ? 'block' : 'none';
          }
          if (modalBadge) {
            // Prioritize % OFF over "Sale" string
            modalBadge.textContent = pdiscount || 'Sale';
            modalBadge.style.display = (pcompare || pdiscount) ? 'block' : 'none';
          }
          
          if (modalATC) { modalATC.setAttribute('data-inv-qty', _invQty); modalATC.setAttribute('data-inv-policy', _invPolicy); }
          if (modalBuy) { modalBuy.setAttribute('data-inv-qty', _invQty); modalBuy.setAttribute('data-inv-policy', _invPolicy); }
          var hasProduct = !!(_variantId || (_productUrl && _productUrl !== 'javascript:void(0)'));
          var contentArea = modalTitle ? modalTitle.parentElement : null;

          if (modalTitle && modalSubtitle && contentArea) {
            modalTitle.textContent = title;
            modalSubtitle.textContent = desc;

            if (hasProduct) {
              /* Left align for products */
              contentArea.style.textAlign = 'left';
              contentArea.style.alignItems = 'flex-start';
              modalTitle.style.textAlign = 'left';
              modalSubtitle.style.textAlign = 'left';
              modalSubtitle.style.marginLeft = '0';
              if (modalPriceRow) modalPriceRow.style.justifyContent = 'flex-start';
            } else {
              /* Center align for placeholders */
              contentArea.style.textAlign = 'center';
              contentArea.style.alignItems = 'center';
              modalTitle.style.textAlign = 'center';
              modalSubtitle.style.textAlign = 'center';
              modalSubtitle.style.marginLeft = 'auto';
              if (modalPriceRow) modalPriceRow.style.justifyContent = 'center';
            }
          }

          if (modalViewProduct) {
            modalViewProduct.href = purl || '#';
            modalViewProduct.textContent = (window.TH_settings && window.TH_settings.view_details_label) || 'View Full Details \u2192';
            modalViewProduct.style.display = (purl && purl !== '#' && purl !== 'javascript:void(0)') ? '' : 'none';
          }
          var hasProduct = !!(_variantId || (_productUrl && _productUrl !== 'javascript:void(0)'));
          
          if (modalNoProduct && modalBuyArea) {
            modalNoProduct.style.display = hasProduct ? 'none' : 'flex';
            modalBuyArea.style.display = hasProduct ? 'flex' : 'none';
            // Update placeholder text if we have a title from the block
            var noProdTitle = document.getElementById('modal-no-product-title');
            if (noProdTitle && title) noProdTitle.textContent = title;
          }
          var isAvailable = trigger.getAttribute('data-product-available') !== 'false';
          if (modalATC) {
            modalATC.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
            modalATC.disabled = !isAvailable;
            modalATC.style.opacity = isAvailable ? '1' : '0.5';
            modalATC.style.pointerEvents = isAvailable ? 'auto' : 'none';
            modalATC.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
          }
          if (modalBuy) {
            modalBuy.disabled = !isAvailable;
            modalBuy.style.opacity = isAvailable ? '1' : '0.5';
            modalBuy.style.pointerEvents = isAvailable ? 'auto' : 'none';
            modalBuy.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
          }
          if (modalPaymentContainer) {
            if (isAvailable) {
              modalPaymentContainer.classList.remove('payment-button-disabled');
            } else {
              modalPaymentContainer.classList.add('payment-button-disabled');
            }
            // Always show the container as per user request
            modalPaymentContainer.style.display = 'block';
          }
          
          if (modalTitle) modalTitle.style.display = hasProduct ? '' : 'none';
          if (modalSubtitle) modalSubtitle.style.display = hasProduct ? '' : 'none';
        }
        
        // Debug function to open modal with placeholders (remove in production)
        window.openMediaModalWithPlaceholders = function() {
          if (modalNoContent) modalNoContent.style.display = 'flex';
          if (modalNoProduct) modalNoProduct.style.display = 'block';
          if (modalBuyArea) modalBuyArea.style.display = 'none';
          if (modalTitle) modalTitle.textContent = '';
          if (modalSubtitle) modalSubtitle.textContent = '';
          modalContent.innerHTML = '';
          
          if (btnPrev) btnPrev.style.display = 'flex';
          if (btnNext) btnNext.style.display = 'flex';
          
          mediaModal.classList.remove('opacity-0', 'pointer-events-none');
          document.body.style.overflow = 'hidden';
        };

        // Modal Click Trigger logic
        document.addEventListener('click', function (e) {
          var trigger = e.target.closest('.media-trigger, .reels-trigger');
          if (!trigger) return;
          e.preventDefault();
          e.stopPropagation();

          _currentParentSection = trigger.closest('[data-product-id], article, .card-shadow') || document.body;
          
          if (trigger.classList.contains('media-trigger')) {
            allTriggers = Array.from(_currentParentSection.querySelectorAll('.media-trigger'));
          } else {
            allTriggers = [trigger]; // No slider for reels
          }
          
          currentIndex = allTriggers.indexOf(trigger);
          if (currentIndex === -1) currentIndex = 0; // fallback just in case
          
          updateModalContent(allTriggers[currentIndex], true);
          mediaModal.classList.remove('opacity-0', 'pointer-events-none');
          document.body.style.overflow = 'hidden';
        });

        // Navigation and touch are handled natively by Swiper

        function closeModal() {
          mediaModal.classList.add('opacity-0', 'pointer-events-none');
          document.body.style.overflow = '';
          
          // Return #pdp-modal-payment-btn-wrap to its original home
          if (window._currentActivePayWrap) {
            var placeholder = document.getElementById('th-pay-wrap-placeholder');
            if (placeholder && placeholder.parentNode) {
              placeholder.parentNode.insertBefore(window._currentActivePayWrap, placeholder);
              placeholder.remove();
            }
            window._currentActivePayWrap = null;
          }

          // Return Card Payment Form to its source
          var cardPh = document.getElementById(window._currentActiveCardPlaceholderId);
          var cardPayWrap = window._currentActiveCardPayWrap;
          if (cardPh && cardPayWrap) {
            // Restore hidden styles
            cardPayWrap.style.opacity = '0';
            cardPayWrap.style.visibility = 'hidden';
            cardPayWrap.style.position = 'absolute';
            cardPayWrap.style.zIndex = '-1';
            cardPayWrap.style.pointerEvents = 'none';
            cardPh.parentNode.insertBefore(cardPayWrap, cardPh);
          }
          window._currentActiveCardPayWrap = null;
          window._currentActiveCardPlaceholderId = null;

          // Restore the original PDP variant ID
          var pdpVariantInput = document.getElementById('pdp-modal-variant-id');
          if (pdpVariantInput && pdpVariantInput.hasAttribute('data-original-value')) {
            pdpVariantInput.value = pdpVariantInput.getAttribute('data-original-value');
            pdpVariantInput.removeAttribute('data-original-value');
          }
          
          if (window.globalModalSwiper) {
            window.globalModalSwiper.destroy(true, true);
            window.globalModalSwiper = null;
          }
          modalContent.innerHTML = '';
          _variantId = null;
          _productUrl = null;
        }
        if (modalClose) modalClose.addEventListener('click', closeModal);
        if (mediaModal) mediaModal.addEventListener('click', function(e){ if (e.target === this) closeModal(); });
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeModal(); });

        if (modalATC) {
          modalATC.addEventListener('click', function () {
            if (!_variantId || modalATC.hasAttribute('disabled')) return;

            /* â”€â”€ Inventory Guard â”€â”€ */
            if (_invPolicy === 'deny' && window.TH && window.TH.cart) {
               const inCart = window.TH.cart.state.items.find(i => i.variant_id == _variantId);
               const qtyInCart = inCart ? inCart.quantity : 0;
               if (qtyInCart >= _invQty) {
                  if (window.Toast) window.Toast.show("The maximum quantity of this item is already in your cart.", 'error');
                  return;
               }
            }

            var btn = this; var orig = btn.textContent;
            btn.setAttribute('data-loading', 'true');
            // Visual feedback: loading state with spinner
            btn.innerHTML = '<svg class="animate-spin h-5 w-5 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0c5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
            btn.disabled = true;
            
            // Use the centralized addItem method to ensure toast, refreshing, and drawer opening
            if (window.TH && window.TH.cart) {
              window.TH.cart.addItem({ id: _variantId, quantity: 1 })
                .then(function() {
                  btn.innerHTML = 'Added âœ“';
                  btn.setAttribute('data-loading', 'false');
                  setTimeout(function(){ btn.innerHTML = orig; btn.disabled = false; }, 1800);
                })
                .catch(function(err) {
                  if (window.Toast) window.Toast.show(err.message || 'Error', 'error');
                  btn.setAttribute('data-loading', 'false');
                  setTimeout(function(){ btn.innerHTML = orig; btn.disabled = false; }, 2000);
                });
            } else {
              // Fallback if global system is not ready
              fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: _variantId, quantity: 1 }) })
                .then(function(r) { return r.json(); })
                .then(function() {
                  btn.innerHTML = 'Added âœ“';
                  setTimeout(function(){ btn.innerHTML = orig; btn.disabled = false; }, 1800);
                });
            }
          });
        }

        /* â”€â”€ Buy Now (modal) - LEGACY CUSTOM LOGIC REMOVED â”€â”€ */
        /* Official Shopify buttons are now handled by modal-payment-button-container */
      })();

/* Active nav hash highlighting */
document.addEventListener('DOMContentLoaded', function () {
  var navItems = document.querySelectorAll('.nav-item');
  function updateActiveLink() {
    var currentHash = window.location.hash;
    var root = (window.TH_settings && window.TH_settings.root_url) || '/';
    if (window.location.pathname === '/' || window.location.pathname === root) {
      navItems.forEach(function (item) {
        var target = item.getAttribute('data-target');
        if (!target) return;
        if ((currentHash === '' && target === 'home') || currentHash === target) {
          item.classList.add('text-fresh');
          item.classList.remove('hover:text-fresh');
        } else {
          item.classList.remove('text-fresh');
          item.classList.add('hover:text-fresh');
        }
      });
    }
  }
  updateActiveLink();
  window.addEventListener('hashchange', updateActiveLink);
});